import * as React from 'react';
import { DataSignal } from 's-js';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { PageAction } from './pagestateenums';

export const ExportToQuickBooksLink = SuperCritical(({ model: m } : { model : {
    MenuAction : (action : () => void) => () => void,
    PageAction : DataSignal<PageAction>
}}) =>
    <a href="" onClick={noDefault(m.MenuAction(() => m.PageAction(PageAction.SelectForExport)))}>
        Export to QuickBooks
    </a>
);


// WEBPACK FOOTER //
// ./apps/portcall/quickbooksexports/exporttoquickbookslink.tsx